import React from "react";
import Helmet from "react-helmet";
import config from "../../data/SiteConfig";
import "./index.css";
import Link from "gatsby-link";
import { slide as Menu } from 'react-burger-menu';

import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';

export default class MainLayout extends React.Component {
  getLocalTitle() {
    function capitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
    const pathPrefix = config.pathPrefix ? config.pathPrefix : "/";
    const currentPath = this.props.location.pathname
      .replace(pathPrefix, "")
      .replace("/", "");
    let title = "";
    if (currentPath === "") {
      title = "Home";
    } else if (currentPath === "tags/") {
      title = "Tags";
    } else if (currentPath === "categories/") {
      title = "Categories";
    } else if (currentPath === "about/") {
      title = "About";
    } else if (currentPath.indexOf("posts")) {
      title = "Article";
    } else if (currentPath.indexOf("tags/")) {
      const tag = currentPath
        .replace("tags/", "")
        .replace("/", "")
        .replace("-", " ");
      title = `Tagged in ${capitalize(tag)}`;
    } else if (currentPath.indexOf("categories/")) {
      const category = currentPath
        .replace("categories/", "")
        .replace("/", "")
        .replace("-", " ");
      title = `${capitalize(category)}`;
    }
    return title;
  }
  render() {
    const { children } = this.props;
    return (
      <div id="OuterContainer">
        <Menu isOpen={false} right pageWrapId="PageContainer" outerContainerId="OuterContainer">
          <Link className="menu-item" to="/">🏠 Home</Link>
          <Link className="menu-item" to="/games">🕹️ Games</Link>
          <Link className="menu-item" to="/blog">📕 Blog</Link>
          <Link className="menu-item" to="/contact">☎️ Contact</Link>
          <a className="menu-item" target="_blank" href="https://twitter.com/sorrystudios">🐤 Twitter</a>
          <a className="menu-item" target="_blank" href="https://instagram.com/sorrystudios">📷 Instagram</a>
        </Menu>
        <Helmet>
          <title>{`${config.siteTitle} |  ${this.getLocalTitle()}`}</title>
          <meta name="description" content={config.siteDescription} />
        </Helmet>
        <Header/>
        <div id="PageContainer">
          {children()}
        </div>
        <Footer config={config}/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layouts/index.jsx